export default "__VITE_ASSET__BNbJw1oW__"